import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import PhoneInput from "react-phone-input-2";
import fr from "react-phone-input-2/lang/fr.json";
import de from "react-phone-input-2/lang/de.json";
import "react-phone-input-2/lib/style.css";
import styles from "./AppTelephone.scss";

export type AppTelephoneProps = {
  name: string;
  value: string;
  setFieldValue?: (field: any, value: any) => void;
  touched?: boolean;
  error?: string;
} & React.ComponentProps<"input">;

const AppTelephone = ({ name, value, setFieldValue, touched, error }: AppTelephoneProps) => {
  const [telephoneValue, setTelephoneValue] = useState(value);
  const { currentLocale } = useAppText();

  const onChangeTelephone = (val: string, country: any, e: any, formattedValue: string) => {
    setTelephoneValue(val);
    if (setFieldValue) setFieldValue(name, formattedValue);
  };

  return (
    <PhoneInput
      inputStyle={{ paddingLeft: "48px", height: "50px", maxWidth: "300px" }}
      containerClass={`${error && touched ? styles.containerError : ""}`}
      inputClass={`${error && touched ? styles.inputError : ""}`}
      country={"ch"}
      masks={{ fr: ". .. .. .. ..", ch: ".. ... .. .." }}
      value={telephoneValue}
      localization={currentLocale === "de" ? de : currentLocale === "en" ? undefined : fr}
      onChange={(value: string, country: any, e: any, formattedValue: string) =>
        onChangeTelephone(value, country, e, formattedValue)
      }
      placeholder="+41 00 000 00 00"
    />
  );
};

export default AppTelephone;
